__turbopack_context__.v({
  "button": "k3CgEq_button",
  "embeddedFormWrapper": "k3CgEq_embeddedFormWrapper",
  "form": "k3CgEq_form",
  "headline": "k3CgEq_headline",
  "iconButton": "k3CgEq_iconButton",
  "subtitleCopy": "k3CgEq_subtitleCopy",
  "titleWrapper": "k3CgEq_titleWrapper",
});
